import {bg, de, es, enUS as en, Locale } from 'date-fns/locale'
import { toAbsoluteUrl } from "../../_metronic/_helpers";

export const languages = [
    {
        lang: "en",
        name: "English",
        nameLocal: "English",
        flag: toAbsoluteUrl("/media/svg/flags/en.svg")
    },
    // {
    //     lang: "bg",
    //     name: "Bulgarian",
    //     flag: toAbsoluteUrl("/media/svg/flags/bg.svg")
    // },
    // {
    //     lang: "es",
    //     name: "Spanish",
    //     flag: toAbsoluteUrl("/media/svg/flags/es.svg")
    // },
    // {
    //     lang: "de",
    //     name: "German",
    //     flag: toAbsoluteUrl("/media/svg/flags/de.svg")
    // },
    // {
    //     lang: "fr",
    //     name: "French",
    //     flag: toAbsoluteUrl("/media/svg/flags/fr.svg")
    // }
];



type IDateLocals = {
  [key: string]: Locale
}

export const DATE_LOCALES_MAP:IDateLocals = {
  bg: bg,
  de: de,
  es: es,
  en: en,
  ['en-US']: en
} 